import Vue from 'vue'
import store from '../store/index'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

// 手机号或身份证号掩码处理
Vue.filter('mask', function (value, maskType) {
    if (!value) return ''
    if (maskType == "phone" && value.length == 11) {
        let maskedValue = value.substr(0, 3) + "****" + value.substr(7, 4);
        return maskedValue;
    } else if (maskType == "idcard" && value.length == 18) {
        let maskedValue = value.substr(0, 4) + "**********" + value.substr(14, 4);
        return maskedValue;
    } else {
        return value;
    }
})

Vue.filter('dateFormat', function (value, formatStr) {
    if (!value) return ''
    let result = "";
    if (!formatStr) {
        result = moment(value).format("YYYY-MM-DD");
    } else {
        result = moment(value).format(formatStr);
    }

    return result;
})

Vue.filter('fromNow', function (date) {
    return moment(date).fromNow()
})

Vue.filter('imgPath', function (imgName) {
    return store.state.hospital.env.imagePath + imgName;
})

Vue.filter('sexFormat', function (value) {
    if (value == 1) return '男'
    else if (value == 2)
        return "女"
    else
        return "";
})

// 通过出生日期计算年龄
Vue.filter('calcAge', function (value) {
    var age = moment().year() - moment(value).year();
    if (moment().subtract(age, 'years').isBefore(moment(value))) {
        age--;
    }
    return age.toString();
})

//价格
const digitsRE = /(\d{3})(?=\d)/g;
Vue.filter('priceFormat', function (value, currency = '元', decimals = 2) {
    value = parseFloat(value);
    if (!value && value !== 0) return '';
    const stringified = Math.abs(value).toFixed(decimals);
    const $int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    const i = $int.length % 3;
    const head = i > 0 ? ($int.slice(0, i) + ($int.length > 3 ? ',' : '')) : '';
    const $float = decimals ? stringified.slice(-1 - decimals) : '';
    const sign = value < 0 ? '-' : '';
    return `${sign}${head}${$int.slice(i).replace(digitsRE, '$1,')}${$float} ${currency}`;
});